/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Bulk upsert serializer for multiple children skill progress.
 */
export interface SkillChildProgressBulkUpsert { 
    firstLevel?: boolean;
    secondLevel?: boolean;
    thirdLevel?: boolean;
    children: Array<string>;
    skill: string;
}